const workplanName = 'workplanName';
const templateDate = 'templateDate';
const shiftlineName = 'shiftlineName';
const shiftlineDate = 'shiftlineDate';
const employeeName = 'employeeName';
const employeeId = 'employeeId';
const employeeStartDate = 'employeeStartDate';
const employeeEndDate = 'employeeEndDate';

export const NotificationTags = Object.freeze({
    [workplanName]: 0,
    [templateDate]: 1,
    [shiftlineName]: 2,
    [shiftlineDate]: 3,
    [employeeName]: 4,
    [employeeId]: 5,
    [employeeStartDate]: 6,
    [employeeEndDate]: 7,
});

export const NotificationTagsKeys = Object.freeze({
    0: workplanName,
    1: templateDate,
    2: shiftlineName,
    3: shiftlineDate,
    4: employeeName,
    5: employeeId,
    6: employeeStartDate,
    7: employeeEndDate,
});
